module.exports = __webpack_public_path__ + "img/36.71df9df0.png";